import { Locale } from '@utils/models';
import { Region } from './constants';
/**
 * Returns a default locale based on region,
 * unless an override locale is provided explicitly.
 */
export function getDefaultLocaleByRegion(region: Region, overrideLocale?: Locale): Locale {
  if (overrideLocale) {
    return overrideLocale;
  }

  switch (region) {
    case Region.US:
      return Locale.enUS;
    case Region.EU:
      return Locale.enGB;
    default:
      return Locale.enGB;
  }
}
